import { useDictationHotkey } from '@/features/dictation/hooks/useDictationHotkey';
import { useChordDisplayTokens } from '@/features/dictation/utils/useChordDisplayTokens';
import { Kbd } from '@heidi/design-system/kbd';
import { TypographyCaption } from '@heidi/design-system/typography';
import { FormattedMessage } from 'react-intl';

export const DictateShortcutTooltipContent = () => {
  const { hotkey } = useDictationHotkey();
  const shortcutTokens = useChordDisplayTokens(hotkey);

  return (
    <TypographyCaption className="flex items-center gap-1 whitespace-nowrap">
      <FormattedMessage
        defaultMessage="Press and hold {shortcut} to dictate into any textbox"
        id="Y740qAD4w2"
        description="Tooltip teaching Ask Heidi users the current Dictate keyboard shortcut"
        values={{
          shortcut: (
            <span className="inline-flex items-center gap-1">
              {shortcutTokens.map((token, index) => (
                <Kbd
                  key={`${token}-${index}`}
                  size="compact"
                  contentClassName="text-text-primary-on-dark"
                >
                  {token}
                </Kbd>
              ))}
            </span>
          ),
        }}
      />
    </TypographyCaption>
  );
};
